<template>
  <div>
    <wc-page-title :loading='isLoading' :title='title' :subtitle='subtitle'>
      
      <template v-slot:rightSide>
        <wc-burger-menu v-if='project'>

          <v-list-item @click='toggleHold' :disabled='project.archived'>
            <v-list-item-icon>
              <v-icon :color='project.on_hold ? "success" : "error"'>{{$icons.hold.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ project.on_hold ? "Remove Project Hold" : "Put Project on hold"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

           <v-list-item @click='toggleArchive'>
            <v-list-item-icon>
              <v-icon :color='project.archived ? "success" : "error"'>{{ project.archived ? "mdi-archive-arrow-up" : "mdi-archive" }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ project.archived ? "Un-archive Project" : "Archive Project"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </wc-burger-menu>
      </template>
    </wc-page-title>

    <v-container v-if='project && project.on_hold' class='mb-n6'>
      <v-alert border='bottom' type='error' :icon='$icons.hold.icon'>This Project has been placed on hold</v-alert>
    </v-container>
    <v-container v-if='project && project.archived' class='mb-n6'>
      <v-alert border='bottom' type='error'>
        This Project is archived. <br>
        <span class='font-italic caption'>
          Don't forget to zero out any invoices and archive them (as well as archiving any open work orders)
        </span>
      </v-alert>
    </v-container>

    <router-view
      v-if='project'
      :project='project'
      @update='update'
    ></router-view>
  </div>
</template>

<script>
import trackerAPI from '@/api/tracker';
import projectsAPI from '@/modules/projects/api/projects';
import lawnAPI from '@/modules/lawn/api';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'lawn-project-base',
  data: () => ({
    isLoading: true,
    project: null
  }),
  computed: {
    title () {
      if (this.project) {
        return this.project.name
      }
      return ''
    },
    subtitle () {
      if (this.project) {
        return this.project.site_address
      }
      return ''
    },
    menu () {
      return [
        {
          title: this.overview.title,
          icon: this.overview.icon,
          route: { name: 'LawnOverview', params: { id: this.$route.params.id } }
        },
        {
          title: this.workorders.title,
          icon: this.workorders.icon,
          route: { name: 'LawnProjectWOs', params: { id: this.$route.params.id } }
        },
        {
          title: this.crewVisits.title,
          icon: this.crewVisits.icon,
          route: { name: 'LawnCrewVisits', params: { id: this.$route.params.id } }
        },
        {
          title: this.invoices.title,
          icon: this.invoices.icon,
          route: { name: 'LawnProjectInvoices', params: { id: this.$route.params.id } }
        },
        {
          title: 'Timesheet Details',
          icon: this.$store.state.icons.modules.timesheets.icon,
          route: { name: 'LawnTimesheetDetails', params: { id: this.$route.params.id } }
        },
        {
          title: this.actionTracker.title,
          icon: this.actionTracker.icon,
          route: { name: 'LawnActionTracker', params: { id: this.$route.params.id } }
        }
      ]
    },
    ...mapState({
      overview: state => state.icons.routes.overview,
      actionTracker: state => state.icons.routes.actionTracker,
      workorders: state => state.icons.modules.workorders,
      invoices: state => state.icons.dataBox.invoices,
      crewVisits: state => state.icons.dataBox.crewVisits,
    })
  },
  mounted () {
    this.getProject()
  },
  methods: {
    async getProject () {
      this.isLoading
      this.project = await projectsAPI.getProject(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', 'Project Menu')
      this.$store.dispatch('loadSubnav', this.menu)
      this.isLoading = false
    },
    async update (project) {
      this.isLoading = true
      await lawnAPI.updateLawnProject(project.project_detail)
      this.project = await projectsAPI.updateProject(project)
      this.isLoading = false
    },
    async recordAction (description) {
      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'project': this.project.id
      }
      trackerAPI.createProjectTracker(tracker);
    },
    toggleArchive () {
      // if/when recycle bin implemented - this will be a one way toggle only, and will need a confirm dialog
      this.project.archived = !this.project.archived
      let description = this.project.archived ? "Project Archived" : "Project has been Un-archived"
      this.recordAction(description);
      this.update(this.project)
    },
    toggleHold () {
      this.project.on_hold = !this.project.on_hold
      let description = this.project.on_hold ? "Project placed on hold" : "Hold removed from Project"
      this.recordAction(description);
      this.update(this.project)
    }
  }
}
</script>